module.exports = __webpack_public_path__ + "static/media/testimonio1.fa3f458c.jpg";